import { useCallback } from 'react'

import history from '@/routes/history'
import utils from '@/utils/utils'

import { MODAL_HOLD_STEPS } from '../constants/config'
import {
  AUTH_LOGIN_PATH,
  AUTH_SIGNUP_PATH,
  buildAuthPageSearch,
  buildLoginPath,
  buildSignupPath,
  getFullReturnPath,
  isAuthPathname,
} from '../utils/auth-return'
import { idleSubmitting } from '../utils/submitting'

/** Limpia flags de flujos abandonados al cerrar el modal. */
export function getModalDismissState () {
  return {
    loginStatus: null,
    closeSessionsStatus: true,
    isFailedLogin: false,
    isSessionExpired: false,
    authNotice: null,
    sessionsData: null,
    errorList: [],
    submittingState: idleSubmitting(),
  }
}

export function useAuthModal ({
  state,
  setState,
  clearPendingCredentials,
  resetTurnstile,
}) {
  const openLoginModal = useCallback(() => {
    if (state.isAuthenticated || utils.isLogged()) return

    const { pathname, search } = window.location
    if (pathname === AUTH_LOGIN_PATH) return

    if (isAuthPathname(pathname)) {
      history.push({
        pathname: AUTH_LOGIN_PATH,
        search: buildAuthPageSearch(search),
      })
      return
    }

    history.push(buildLoginPath(getFullReturnPath(window.location)))
  }, [state.isAuthenticated])

  const openSignupModal = useCallback(() => {
    if (state.isAuthenticated || utils.isLogged()) return

    const { pathname, search } = window.location
    if (pathname === AUTH_SIGNUP_PATH) return

    if (isAuthPathname(pathname)) {
      history.push({
        pathname: AUTH_SIGNUP_PATH,
        search: buildAuthPageSearch(search),
      })
      return
    }

    history.push(buildSignupPath({
      returnPath: getFullReturnPath(window.location),
      currentSearch: search,
    }))
  }, [state.isAuthenticated])

  const openForgotPasswordModal = useCallback(() => {
    if (state.isAuthenticated || utils.isLogged()) return

    const { pathname, search } = window.location
    if (pathname === AUTH_LOGIN_PATH) return

    if (isAuthPathname(pathname)) {
      history.push({
        pathname: AUTH_LOGIN_PATH,
        search: buildAuthPageSearch(search),
      })
      return
    }

    history.push(buildLoginPath(getFullReturnPath(window.location)))
  }, [state.isAuthenticated])

  const closeModal = useCallback(() => {
    const canClose = !MODAL_HOLD_STEPS.includes(state.loginStatus)
    if (canClose) {
      clearPendingCredentials?.()
      resetTurnstile?.()
      setState(getModalDismissState())
    }
  }, [clearPendingCredentials, resetTurnstile, setState, state.loginStatus])

  const setAuthPageStep = useCallback((step) => {
    setState({ authPageStep: step })
  }, [setState])

  const setAuthNotice = useCallback((authNotice) => {
    setState({ authNotice })
  }, [setState])

  return {
    openLoginModal,
    openSignupModal,
    openForgotPasswordModal,
    closeModal,
    setAuthPageStep,
    setAuthNotice,
  }
}
